module.exports = __webpack_public_path__ + "img3.8124c43.png";